import React from 'react';
import { Menubar } from 'primereact/menubar';
import { Galleria } from 'primereact/galleria';
import './App.css';
import Contacto from './Contact';
import FloatingIconsOnScroll from './FloatingMusic';
import YouTubeShortsGallery from './YoutubeVideos';
import Resume from './Resume';

// import { Button } from 'primereact/button';

function App() {
  const items = [
    { label: 'Inicio', command: () => scrollToSection('nosotros') },
    { label: 'Génesis', command: () => scrollToSection('genesis') },
    { label: 'Proyecto Ensamble', command: () => scrollToSection('proyecto') },
    { label: 'Contacto', command: () => scrollToSection('contacto') }
  ];
  // const [activeIndex, setActiveIndex] = useState(0);
  // const [visible, setVisible] = useState(false);

  const galleryItems = [
    { type: 'image', itemImageSrc: '/ensayo1.jpeg', alt: 'Ensayo 1' },
    { type: 'image', itemImageSrc: '/ensayo2.jpeg', alt: 'Ensayo 2' },
    { type: 'image', itemImageSrc: 'https://sntnsownwrjfgmydxmia.supabase.co/storage/v1/object/public/temp-realstate//ensayo3%20(1).png', alt: 'Ensayo 3' },
    { type: 'image', itemImageSrc: '/ensayo4.jpeg', alt: 'Ensayo 4' },
    { type: 'image', itemImageSrc: '/ensayo5.jpeg', alt: 'Ensayo 5' },
    { type: 'image', itemImageSrc: '/ensayo6.jpeg', alt: 'Ensayo 6' },
    { type: 'image', itemImageSrc: '/IMG_20250502_162813.jpg', alt: 'Presentación 1' },
    { type: 'image', itemImageSrc: '/IMG_20250508_175258.jpg', alt: 'Evento 2' },
    { type: 'image', itemImageSrc: '/alumno-classinc.png', alt: 'Evento 3' },
    { type: 'image', itemImageSrc: '/IMG_20250412_105743.jpg', alt: 'Intrumentos' },
    { type: 'image', itemImageSrc: '/IMG_20240817_172525_490.jpg', alt: 'Ensayo' }
  ];

  const itemTemplate = (item) => {
    if (item.type === 'image') {
      return <img src={item.itemImageSrc} alt={item.alt} style={{ width: '100%', height: 'auto' }} />;
    }
    if (item.type === 'video') {
      return (
        <video controls width="100%" style={{ maxHeight: '500px' }}>
          <source src={item.videoSrc} type="video/mp4" />
          Tu navegador no soporta el video.
        </video>
      );
    }
    return null;
  };

  const thumbnailTemplate = (item) => {
    if (item.type === 'image') {
      return <img src={item.itemImageSrc} alt={item.alt} style={{ width: '100%', height: 'auto' }} />;
    }
    if (item.type === 'video') {
      return (
        <div style={{ width: '100px', height: '60px', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '12px' }}>
          ▶ Video
        </div>
      );
    }
    return null;
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <FloatingIconsOnScroll />
      {/* NAVBAR */}
      <Menubar model={items} className="fixed top-0 w-full z-5" start={<div className='navbar-brand'>The Class Inc</div>} />

      {/* INICIO */}
      <section className="p-5 text-center mt-5" id='inicio'>
        <div style={{paddingTop: '130px'}}>
          <h1 className="mb-2" style={{color: 'white', fontSize: '60px'}}>The Class Inc</h1>
        </div>
        {/* <img src="./IMG_20250524_145053.jpg" alt="Génesis Murguía" style={{ width: '200px', borderRadius: '50%' }} /> */}
      </section>

      <section className="p-5" id='nosotros'>
          <article className="card">
            <header className="card-header">
              <h3 className="card-title">¿Quienes Sómos?</h3>
              <span className="card-meta">
              </span>
            </header>
            <div className="card-body" id='logros'>
<p>              Theclassinc es un espacio de expresión musical principalmente orientado hacia aquellos amantes de la música que desean aprender y desarrollar habilidades principalmente en el canto, sin dedicarse a ello profesionalmente. Así, el objetivo del proyecto es incorporar a los estudiantes de Theclassinc a los ensambles musicales para realizar presentaciones en diversos escenarios.
</p>
            </div>
          </article>


          <article className="card">
            <header className="card-header">
              <h3 className="card-title">Nuestra misión</h3>
              <span className="card-meta">
              </span>
            </header>
            <div className="card-body" id='logros'>
<p>    Inspirar a la sociedad en el aprendizaje de la música y su ejecución en diversos escenarios, mostrando que es posible combinar la realización de sus sueños musicales con su vida cotidiana.
</p>
            </div>
          </article>
       
      </section>


            {/* Aptitudes  */}
            <section id="genesis" className="p-5">
            <h1 className="mb-2 destacado" style={{color: 'white', fontSize: '40px' }}>Génesis Anaís Murguía Madrigal</h1>
            <h3 className="mb-4 destacado" style={{ fontSize: '30px' }}>Licenciada en Música - Especialidad en Canto</h3>
            <article className="card">
            <header className="card-header">
              <h3 className="card-title">Perfil Profesional</h3>
              <span className="card-meta">
              </span>
            </header>
            <div className="card-body" id='logros'>
              <p>  Mi formación dentro de la Universidad de Sonora me permite desempeñar actividades de desarrollo del aprendizaje para todas las edades de acuerdo a las necesidades del proyecto que se desarrolle dentro del ámbito docente, enfocado a la enseñanza del canto, solfeo, piano, coro y apreciación musical, así como también diferentes tipos de instrumentos que sean soporte para la iniciación musical, de manera que puedan aprender y disfrutar de tocar o cantar sea la edad que tengan o el grupo al que pertenezcan.
          A través de los 5 años que tengo como músico, ya sea brindando clases particulares he trabajado con diferentes grupos de personas o como cantante, he adquirido la experiencia para adaptarme a las necesidades que se presenten mostrando siempre la actitud de servicio y de aprendizaje ante cualquier obstáculo que pueda llegar a presentarse.
          Cuento con el conocimiento necesario para manejar las herramientas digitales necesarias para la oferta y demanda de la enseñanza en línea y presencial.
</p>

            </div>
          </article>
        <Resume />
        

      </section>

      <section className="experiencia">
          <article className="card">
            <header className="card-header">
              <h3 className="card-title">Logros y Expectativas</h3>
              <span className="card-meta">
              </span>
            </header>
            <div className="card-body" id='logros'>
              <p>Considero un logro el concluir mi carrera y poder encontrar algunas partes en donde desarrollarme profesionalmente, el vivir como músico tanto de calle como músico profesional y ser profesor a tiempo parcial de la misma materia ejercida, siento que me han proporcionado las bases necesarias para poder transmitir el conocimiento adquirido a través de los años.</p>
              <p>Considero que hoy en la actualidad es importante contar con las nuevas tecnologías para poder alcanzar a aquellas personas que pasan más tiempo en línea usando las redes sociales para cubrir el posible sector que desconoce de los servicios existentes y abrir nuevas posibilidades de conocimiento en diferentes aspectos sociales y económicos.</p>

            </div>
          </article>
       
      </section>




      <section className="proyecto" id='proyecto'>
      <h1 className="mb-2 destacado" style={{color: 'white', fontSize: '40px', width:'100%' }}>PROYECTO ENSAMBLE</h1>  
          <article className="card">
            <header className="card-header">
              <h3 className="card-title">Antecedentes</h3>
              <span className="card-meta">
              </span>
            </header>
            <div className="card-body" id='logros'>
<p>       El proyecto de ensamble de TheClassInc inició en agosto del 2024 y actualmente cuenta con tres integrantes: Génesis, Ailyn y Enrique. El repertorio actual se enfoca en géneros de pop, rock y baladas en inglés y español, de las décadas de los 80's, 90's y 2000's principalmente. Este repertorio está en función de las propuestas que cada integrante del ensamble realiza y de los instrumentos que se dominan, buscando temas que sean atractivos para la audiencia sin caer en canciones alusivas a cualquier tipo de violencia. 
</p>
            </div>
          </article>
       
      </section>


      <section className="integrantes">
          <article className="card">
            <header className="card-header"  id='integrantes'>
              <h3 className="card-title">Integrantes actuales</h3><br/><br/>
             
            </header>
            <span className="card-meta" id='integrantes'>
              Génesis (Voces, teclado, guitarra)
              </span><br/>
            <div className="card-body" id='logros'>
<p>     Génesis es la directora artística. Es cantante mezzosoprano, quien desde niña supo que quería formar parte de los escenarios, de modo que, desde los 9 años empezó su carrera musical en pequeñas presentaciones escolares. Aprendió guitarra popular y ukelele a los 12 años y, en el 2018, estudió la licenciatura en música con especialización en el canto. Ha formado parte de diferentes grupos como rondallas, solista o coros. Actualmente, con el ensamble de TheClassInc lleva a cabo las actividades que más le gustan: enseñar, practicar y ensamblar desde lo más fácil hasta los detalles más complicados, ejecutando música que siempre quizo tocar o cantar con la compañía de sus alumnos, esperando que disfruten ser parte de esta experiencia. Sus géneros favoritos son el metal, rock y pop.

</p>
            </div>

            <div className="card-body" id='logros'>
            <header className="card-header"  id='integrantes'>
              <h3 className="card-title"></h3>
              <span className="card-meta" id='integrantes'>
              Enrique (Voces, guitarra, violín)
              </span>
            </header>
<p>    Enrique tiene 46 años y es geólogo de profesión, especializado en hidrogeología. Actualmente trabaja como consultor para diversas empresas. Durante sus estudios universitarios tomó clases de guitarra clásica y violín, y desde el 2024, de canto. Desde joven tuvo la inquietud de formar parte de ensambles de música, pero por sus actividades profesionales y familiares se le complicaba. Hace un año decidió hacer un esfuerzo por cumplir esta meta, por lo que inició el proyecto de TheClassinc junto con génesis, con el fin de incorporar a otros amantes de la música que, como él, tengan el anhelo de formar parte de un ensamble, pero cuentan con tiempo limitado. Sus géneros favoritos son el rock, el pop y las baladas tanto en inglés como en español.

</p>
            </div>

            <div className="card-body" id='logros'>
            <header className="card-header"  id='integrantes'>
              <h3 className="card-title"></h3>
              <span className="card-meta" id='integrantes'>
              Ailyn (Voces)
              </span>
            </header>
<p>   Ailyn es Lic. en Psicología y actualmente ejerce su profesión. Desde jovén tuvo la inquietud de formar parte de un grupo de música, por lo que le llena de alegría estar cumpliendo esta meta. Además, considera que su participación en el ensamble le está ayudando mucho a romper muchos miedos y confiar más en si misma.

</p>
            </div>
          </article>
       
      </section>

      

      

      {/* PROYECTOS */}
      <section id="proyectos" className="p-5">
        <div className="grid">

          {/* <div className="col-12 md:col-6 text-center mb-3">
            <video width="50%" controls>
              <source src="/20231226_1507251.mp4" type="video/mp4" />
              Tu navegador no soporta el video.
            </video>
          </div>
          <div className="col-12 md:col-6">
            <img src="/IMG_20250502_162813.jpg" alt="Presentación musical" className="w-full border-round" />
          </div> */}
          <Galleria
            value={galleryItems}
            numVisible={5}
            circular
            style={{ maxWidth: '800px', margin: '0 auto' }}
            item={itemTemplate}
            thumbnail={thumbnailTemplate}
            showThumbnails
            showItemNavigators
            showIndicators
          />

    
        </div>

      </section>

      <section className='p-5' id='shorts'>
      <h2 className='text-center mb-4'></h2>

                <div className="grid text-center">
                <YouTubeShortsGallery
          urls={[
            "https://youtube.com/shorts/SH32G2SuGjQ?feature=share",
            "https://youtu.be/4n4y0I3M1yQ",
            "https://youtu.be/XlS1_q_MfW0",
          ]} />
          </div>
      </section>

      {/* CONTACTO */}
      <section id="contacto" className="p-5 surface-50">
        <h2 className="text-center mb-4">Contacto</h2>
        <p className="text-center">Puedes contactarme a través del correo: <strong>jennmurguia@gmail.com </strong></p>
        <p className="text-center">Cel: <strong>6624217646  </strong></p>
        <p className="text-center">Teléfono: <strong>6622672404  </strong></p>
        <br></br>
        <Contacto />
        {/* Aquí podrías agregar un formulario si quieres */}
      </section>

      {/* FOOTER */}
      <footer className="p-4 bg-gray-900 text-white text-center mt-5">
        <p>&copy; {new Date().getFullYear()} Génesis Murguía. Todos los derechos reservados.</p>
      </footer>
    </>
  );
}

export default App;
